import React, { FC, ReactNode } from 'react';
import LegalReacceptanceProgressBar from 'containers/legal-reacceptance/LegalReacceptanceProgressBar';

export interface LegalReacceptanceShellProps {
  currentStep: number;
  /** When false, hides the step progress bar (e.g. bank-only wallet reminder). Default true. */
  showProgressBar?: boolean;
  children: ReactNode;
}

const LegalReacceptanceShell: FC<LegalReacceptanceShellProps> = ({ currentStep, showProgressBar = true, children }) => {
  return (
    <div className="flex max-h-[min(90vh,660px)] min-h-0 flex-1 flex-col">
      {showProgressBar ? (
        <div className="shrink-0 px-8 pt-6">
          <LegalReacceptanceProgressBar currentStep={currentStep} />
        </div>
      ) : null}
      <div className="flex min-h-0 flex-1 flex-col overflow-y-auto">{children}</div>
    </div>
  );
};

export default LegalReacceptanceShell;
